import { Row, Col, Container } from "react-bootstrap";
const ComingSoon = () => {

    return (<>
        <section>
            <div className="container py-5">
                <div className="card text-center border-0 shadow rounded-4">
                    <div className="card-body py-5">

                        <div className="display-6 mb-3">🚀</div>

                        <h2 className="fw-bold mb-3">Coming Soon</h2>

                        <p className="text-muted mb-4">
                            We're preparing something exciting for you.
                            Check back soon!
                        </p>

                        {/* <button className="btn btn-success rounded-pill px-4">
                            Stay Tuned
                        </button> */}

                    </div>
                </div>
            </div>


        </section>
    </>)
}

export default ComingSoon;